import { map } from "ramda";
import * as React from "react";
import {
  AccountPresenter,
  AccountPresenterKind
} from "../model/presenter/types";
import { RuleChangeLog, RuleHistory } from "../model/spread/types";
import CalculatedAccountSection from "./CalculatedAccountSection";
import ValueAccountSection from "./ValueAccountSection";

interface ChildAccountsSectionProps {
  childAccounts: AccountPresenter[];
  hierarchyLevel: number;
  ruleHistory: RuleHistory;
  initialChangelog: RuleChangeLog;
  periods: string[];
}

export class ChildAccountsSection extends React.Component<
  ChildAccountsSectionProps,
  {}
> {
  public render() {
    const {
      childAccounts,
      hierarchyLevel,
      ruleHistory,
      initialChangelog,
      periods
    } = this.props;

    return (
      <div className="ChildAccountsSection">
        {map(child => {
          switch (child.type) {
            case "CALCULATED":
              return (
                <CalculatedAccountSection
                  account={child as AccountPresenterKind<"CALCULATED">}
                  hierarchyLevel={hierarchyLevel}
                  key={child.id}
                  ruleHistory={ruleHistory}
                  initialChangelog={initialChangelog}
                  periods={periods}
                />
              );
            case "VALUE":
              return (
                <ValueAccountSection
                  account={child as AccountPresenterKind<"VALUE">}
                  key={child.id}
                  hierarchyLevel={hierarchyLevel}
                  ruleHistory={ruleHistory}
                  initialChangelog={initialChangelog}
                  periods={periods}
                />
              );
            case "HIDDEN":
            case "ROOT":
              // TODO: Remove null return and convert to exception once all hidden accounts
              // are only under value accounts
              return null;
            // throw Error(`Hidden Account: ${child.name} under calcuated account`)
          }
        }, childAccounts)}
      </div>
    );
  }
}

export default ChildAccountsSection;



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/ChildAccountsSection.tsx